import React, { ReactNode } from 'react';

export interface SignupForm {
	fullName: string;
	email: string;
	phone_number: string;
	password: string;
	get_to_know: string;
}

export interface AuthLayoutProps {
	children: ReactNode;
	backgroundType: string;
}

export type TypeProp = 'email' | 'phone_number';

export enum AuthType {
	EMAIL = 'email',
	PHONE_NUMBER = 'phone_number',
}

export interface SignUpSuccessModalProps {
	isOpen: boolean
	onClose: () => void
	responseText?: string
}

export interface LoginDataProps {
	email?: string
	phone_number?: string
	password?: string
}

export interface SignUpDataProps {
	email?: string
	phone_number?: string
	password?: string
	fullName?: string
}

export interface ValidateUserProps {
	userId?: string
	otp?: string
}

export interface NewPasswordProps {
	password?: string
	confirm_password?: string
}

export interface RecoverPasswordProps {
	email?: string
	phone_number?: string
}

export interface LocationProps {
    id?: string;
    branchId?: number;
    name?: string;
    address?: string | null;
    lga?: string | null;
    state?: string | null;
    isActive?: boolean;
} 